import {
  Component,
  computed,
  contentChildren,
  forwardRef,
  input,
  model,
  output,
} from '@angular/core';
import { SwitchBarOption } from '../switch-bar-option/switch-bar-option';
import { FormValueControl } from '@angular/forms/signals';

@Component({
  selector: 'ui-switch-bar',

  templateUrl: './switch-bar.html',
  styleUrls: ['./switch-bar.css'],
})
export class SwitchBar implements FormValueControl<unknown> {
  private readonly radios = contentChildren(forwardRef(() => SwitchBarOption));

  fieldValueChange = output<unknown>();

  readonly value = model<unknown>(null);
  readonly disabled = input<boolean>(false);
  readonly touched = model<boolean>(false);
  readonly name = input<string>(crypto.randomUUID());

  readonly vertical = input<boolean>(false);

  protected readonly children = computed(() => this.radios().length);

  onRadioChange(value: unknown): void {
    this.value.set(value);
    this.touched.set(true);
    this.fieldValueChange.emit(value);
  }
}
